var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lot
    ? _c("div", { staticClass: "page" }, [
        _c("div", { staticClass: "page-main" }, [
          _c("div", { staticClass: "page-header" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-md-12 col-lg-12 col-xl-12 col-xxl-10 offset-xxl-1",
              },
              [
                _c("h1", { staticClass: "page-title" }, [_vm._v("Prize Lot")]),
                _c("breadcrumb", {
                  attrs: {
                    name: "PRIZE_SUMMARY_LOT_EDIT",
                    withLast: _vm.lot.lot_name,
                  },
                  on: {
                    "update:withLast": function ($event) {
                      return _vm.$set(_vm.lot, "lot_name", $event)
                    },
                    "update:with-last": function ($event) {
                      return _vm.$set(_vm.lot, "lot_name", $event)
                    },
                  },
                }),
                _c("div", { staticClass: "page-title page-header-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-round btn-default mx-10",
                      attrs: { type: "button" },
                      on: { click: _vm.goBack },
                    },
                    [
                      _c("i", {
                        staticClass: "icon md-chevron-left",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" Back "),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "page-content container-fluid" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-12 col-lg-12 col-xl-12 col-xxl-10 offset-xxl-1",
                },
                [
                  _c("div", { staticClass: "panel panel-bordered" }, [
                    _c("div", { staticClass: "panel-heading" }, [
                      _c("h3", { staticClass: "panel-title" }, [
                        _vm._v(
                          " Prize Lot Information - " + _vm._s(_vm.lot.id) + " "
                        ),
                      ]),
                      _c("div", {
                        staticClass: "panel-actions panel-actions-keep",
                      }),
                    ]),
                    _c("div", { staticClass: "panel-body" }, [
                      _vm.lot
                        ? _c(
                            "form",
                            { staticClass: "form-horizontal" },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group col-md-6" },
                                  [
                                    _c("LotName", {
                                      attrs: { lot: _vm.lot },
                                      on: { updated: _vm.fetchLot },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "form-group col-md-3" },
                                  [
                                    _c("StatusDropdown", {
                                      attrs: { lot: _vm.lot },
                                      on: { updated: _vm.fetchLot },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("hr"),
                              _c("PrizeLotDate", {
                                attrs: { lot: _vm.lot },
                                on: { updated: _vm.fetchLot },
                              }),
                              _c("hr"),
                              _c("PrizeSource", {
                                attrs: { lot: _vm.lot },
                                on: { updated: _vm.fetchLot },
                              }),
                              _c("hr"),
                              _vm.lot.prize_source == "manual"
                                ? _c(
                                    "div",
                                    { staticClass: "prize-detail-section" },
                                    [
                                      _c("h4", [_vm._v("Prize Details")]),
                                      _c("PrizeName", {
                                        attrs: { lot: _vm.lot },
                                        on: { updated: _vm.fetchLot },
                                      }),
                                      _c("br"),
                                      _c("PrizeDescription", {
                                        attrs: { lot: _vm.lot },
                                        on: { updated: _vm.fetchLot },
                                      }),
                                      _c("br"),
                                      _c("PrizePicture", {
                                        attrs: { lot: _vm.lot },
                                        on: { updated: _vm.fetchLot },
                                      }),
                                      _c("br"),
                                      _c("RequireAddress", {
                                        attrs: { lot: _vm.lot },
                                        on: { updated: _vm.fetchLot },
                                      }),
                                      _c("hr"),
                                      _c("LineNotification", {
                                        attrs: { lot: _vm.lot },
                                        on: { updated: _vm.fetchLot },
                                      }),
                                      _c("hr"),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("Recipients", {
                                attrs: { lot: _vm.lot },
                                on: { uploaded: _vm.fetchLot },
                              }),
                              _c("hr"),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm._m(0),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-footer" }, [
      _c("div", { staticClass: "d-flex justify-content-between" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }